import React from "react";
import Form_DentalPetV2 from "../../form/form_dentalpetV2";

export default function Form_DentalPetV2VMCUC() {
  const clinic_id = "66aac5ba721beda869ab64c1";

  return (
    <div className="w-full flex justify-center items-center">
      <Form_DentalPetV2 clinic_id={clinic_id} />
    </div>
  );
}
